import { Dialog } from "@headlessui/react";

import Button from "../../../components/atoms/button";

interface DialogProps {
  isShow: boolean;
  onConfirm: () => void;
  setOpen: (val: boolean) => void;
  buttonName: string;
  heading: string;
  message: string;
  icon: any;
  onContinue: () => void;
  showContinueButton?: boolean;
}

const SimpleDialogModal = ({
  isShow,
  onConfirm,
  buttonName,
  setOpen,
  heading,
  message,
  onContinue,
  icon,
  showContinueButton = true
}: DialogProps) => {
  const closeModal = () => {
    setOpen(false);
  };
  const btnClick = () => {
    setOpen(false);
    onContinue();
  };
  const handleLogout = () => {
    setOpen(false);
    onConfirm();
  };

  return (
    <>
      <div className=" w-full ">
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <Dialog.Title
            as="h3"
            className="text-lg font-semibold leading-6 text-gray-900 dark:text-gray-50 mt-7"
          >
            <div className="flex flex-row ">
              <span className="mt-1">{icon}</span>
              <span className="px-2">{heading}</span>
            </div>
          </Dialog.Title>
          <div className="my-4 text-base">{message}</div>
        </div>
      </div>
      <div className="mt-5 sm:mt-4 mr-2 flex justify-center space-x-2 md:mb-3 mb-5">
        {showContinueButton && (
          <Button
            label={buttonName}
            variant="contained"
            buttonColor="primary"
            onClick={btnClick}
            testId={`${buttonName?.replace(/\s/g, "")}btn`}
          />
        )}
        <div className="mr-2 ">
          {" "}
          <Button
            label="Logout"
            variant="outlined"
            buttonColor="secondary"
            onClick={handleLogout}
            testId="closeModalBtn"
          />
        </div>
      </div>
    </>
  );
};

export default SimpleDialogModal;
